import Bloc from './Bloc.js';
import Types from './Types.js';

export default class ForEachEnemy extends Bloc {

	constructor (src, ctx) {

		super("forenemy", src, ctx, true);
		this.f = (src, ins, props) => {
			/*let lock = !src.game.broadcaster.locked;
			if (lock)
				src.game.broadcaster.lock();*/
			var enemies = src.master.liveEnemies;
			enemies.forEach(enemy => {
				this.out = [enemy];
				if (this["for each"])
					this["for each"].execute(props);
			})
			/*if (lock)
				src.game.broadcaster.unlock();*/
			this.out = null;
			if (this.completed)
				this.completed.execute(props);
			return;
		}
		this.types = [Types.cardfilter];
		this.toPrepare.push("for each");
		this.toPrepare.push("completed");
	}
}
